import Input from "@Components/Input";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

import styles from "./Dropdown.module.scss";
import { useEffect, useRef, useState } from "react";
import useClickOutside from "hooks/useOutsideClick";
import DropdownIcon from "@Icons/DropdownIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const Dropdown = ({
  value,
  label,
  placeholder,
  handleOptionClick,
  clearable,
  onFocus,
  options,
  // showOptions,
  handleClear,
  showErrorMessage,
  error,
  required,
  disabled,
  onChange,
  handleOutsideClick,
  dropdownContainerClassName,
  dataTestId,
  CustomDropdownOption,
  optionsContainerClass = "",
  showPlaceholderAndLabel = false,
}: any) => {
  const dropdownRef = useRef(null);
  const [inpValue, setInpValue] = useState(value);
  const [showOptions, setShowOptions] = useState("");
  useEffect(() => setInpValue(value), [value]);

  const { t } = useTranslationHook();

  useClickOutside(dropdownRef, () => {
    if (typeof handleOutsideClick !== undefined && showOptions === label) {
      handleOutsideClick();
      setShowOptions("");
    }
  });

  return (
    <div
      className={formatClassNames(styles.dropdownContainer, dropdownContainerClassName)}
      ref={dropdownRef}
    >
      <Input
        dataTestId={dataTestId}
        type="dropdown"
        label={t(label)}
        placeholder={placeholder}
        value={inpValue ? options[inpValue] : ""}
        onFocus={() => {
          onFocus();
          setShowOptions(label);
        }}
        clearable={clearable}
        handleClear={() => {
          setInpValue("");
          setShowOptions("");
          handleClear();
        }}
        showErrorMessage={showErrorMessage}
        error={error}
        required={required}
        disabled={disabled}
        onChange={onChange}
        readOnly
        containerClassName={styles.dropdownInput}
        rightIcon={!inpValue && <DropdownIcon size={15} />}
        showPlaceholderAndLabel={showPlaceholderAndLabel}
      />
      {showOptions === label && Object.keys(options).length > 0 && (
        <div className={formatClassNames(styles.options_container, optionsContainerClass)}>
          {Object.keys(options).map((opt: any, idx: number) =>
            CustomDropdownOption ? (
              <CustomDropdownOption
                id={`${options[opt]}-${idx}`}
                option={opt}
                isSelected={inpValue == opt}
                onClick={() => {
                  handleOptionClick(opt);
                  handleOutsideClick();
                  setShowOptions("");
                }}
                label={options[opt]}
              />
            ) : (
              <div
                className={formatClassNames(styles.option, inpValue == opt ? styles.selected : "")}
                key={`${opt.label}-${idx}`}
                role="none"
                onClick={() => {
                  handleOptionClick(opt);
                  handleOutsideClick();
                  setShowOptions("");
                }}
              >
                <div>{options[opt]}</div>
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(Dropdown, {
  componentName: "Dropdown-BookForm",
  showForChina: true,
});
